import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const logisticTypes = {
    transporter: "transporter"
}

export const targetTypes = {
    transporter: "transporter"
}

export const transportTypes = [
    "Own Vehicle",
    "Courier",
    "ETC"
]

export function useLogistics({
    logisticType: _logisticType,
    targetType: _targetType
}) {

    const [logisticType, setLogisticType] = useState(_logisticType);
    const [targetType, setTargetType] = useState(_targetType)

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "logistics";
    const endpoint2 = "logistic";

    const list = async (props) => {

        setIsLoading(true);

        try {

            let { logisticType: overrideLogisticType } = props

            let url = getListsUrl(`${endpoint}/${logisticType}`, props)

            if (overrideLogisticType) {
                url = getListsUrl(`${endpoint}/${overrideLogisticType}`, props)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const create = async ({ data }) => {

        setIsLoading(true)

        try {

            const url = endpoint2;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/${id}`

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            // let url = `${endpoint}/${repositoryType}/delete`
            let url = `${endpoint}/delete`

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id, logisticType: overrideLogisticType = '', dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = getUrlWithDataTypes(`${endpoint2}/${logisticType}/${id}`, dataTypesArray);

            if (overrideLogisticType) {
                url = getUrlWithDataTypes(`${endpoint2}/${overrideLogisticType}/${id}`, dataTypesArray);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        transportTypes,
        list,
        get,
        create,
        update,
        remove
    }
}